export type HasFiscalPrinter = () => boolean;

/*
 * Service hasFiscalPrinter—function that returns ture if fiscalPrinter is on
 */
angular.module('posApp').factory('hasFiscalPrinter', (settingsManager) => {
  return () => {
    if (settingsManager.settings.fiscalPrinter?.active) {
      return true;
    }

    return false;
  };
});
